module.exports = __webpack_public_path__ + "static/media/obestinado_d.10360b85.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/badges/obestinado_d.png
// module id = 1150
// module chunks = 0